/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: mzA6SGO_FrzS
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicButtonDock.module.css"; // plasmic-import: mzA6SGO_FrzS/css
import Workspace1024PxIcon from "./icons/PlasmicIcon__Workspace1024Px"; // plasmic-import: pwj1vvvDK2dP/icon

createPlasmicElementProxy;

export const PlasmicButtonDock__VariantProps = new Array("type");

export const PlasmicButtonDock__ArgProps = new Array("iconTab", "onClick");

const $$ = {};

function PlasmicButtonDock__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.type
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"dockButtonWrapper"}
      data-plasmic-override={overrides.dockButtonWrapper}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.dockButtonWrapper,
        {
          [sty.dockButtonWrappertype__default]: hasVariant(
            $state,
            "type",
            "_default"
          ),
          [sty.dockButtonWrappertype_withLine]: hasVariant(
            $state,
            "type",
            "withLine"
          )
        }
      )}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
    >
      <div
        data-plasmic-name={"dockButton"}
        data-plasmic-override={overrides.dockButton}
        className={classNames(projectcss.all, sty.dockButton)}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <div
              className={classNames(projectcss.all, sty.freeBox__cb7O, {
                [sty.freeBoxtype_withLine__cb7Oh6OPs]: hasVariant(
                  $state,
                  "type",
                  "withLine"
                )
              })}
            >
              <Workspace1024PxIcon
                className={classNames(projectcss.all, sty.svg__yjkT0)}
                role={"img"}
              />
            </div>
          ),

          value: args.iconTab
        })}
      </div>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxtype__default]: hasVariant($state, "type", "_default"),
          [sty.freeBoxtype_withLine]: hasVariant($state, "type", "withLine")
        })}
      />
    </div>
  );
}

const PlasmicDescendants = {
  dockButtonWrapper: ["dockButtonWrapper", "dockButton", "freeBox"],
  dockButton: ["dockButton"],
  freeBox: ["freeBox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonDock__ArgProps,
          internalVariantPropNames: PlasmicButtonDock__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonDock__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "dockButtonWrapper") {
    func.displayName = "PlasmicButtonDock";
  } else {
    func.displayName = `PlasmicButtonDock.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonDock = Object.assign(
  // Top-level PlasmicButtonDock renders the root element
  makeNodeComponent("dockButtonWrapper"),
  {
    // Helper components rendering sub-elements
    dockButton: makeNodeComponent("dockButton"),
    freeBox: makeNodeComponent("freeBox"),
    // Metadata about props expected for PlasmicButtonDock
    internalVariantProps: PlasmicButtonDock__VariantProps,
    internalArgProps: PlasmicButtonDock__ArgProps
  }
);

export default PlasmicButtonDock;
/* prettier-ignore-end */
